export class InstitutionResponseDto {
  countries: string[]
  id: string
  logo: string
  name: string
  bic: string
  transaction_total_days: string
  max_access_valid_for_days: string
}
